<template>
  <component :is="`video-${blockStyle}`" :blockProperty="sectionSelected.settings.style">
    <fremcast-image :video="data" slot="image"/>
    <vm-image-background :video="data" slot="image-bg"/>

    <video-route
      :class="{[`${showVideoDetails(sectionSelected.settings)}`]: true}"
      :video="data"
      :blockId="sectionSelectedBlockId"
      :sectionId="sectionSelectedId"
      :fontColor="sectionSelected.settings.style.fontColor"
      slot="video-route"
    />

    <custom-route
      :video="data"
      :blockId="sectionSelectedBlockId"
      :sectionId="sectionSelectedId"
      :fontColor="sectionSelected.settings.style.fontColor"
      slot="custom-route"
    />

    <template slot-scope="props" slot="icon-route">
      <icon-route
        :iClass="props.iClass"
        :aClass="props.aClass"
        :video="data"
        :blockId="sectionSelectedBlockId"
        :sectionId="sectionSelectedId"
      />
    </template>

    <v-img slot="raw-image" :src="data.image"/>

    <p
      slot="title"
      class="video-title pt-4"
      :style="{ color: sectionSelected.settings.style.fontColor }"
    >
      {{ data.title }}
    </p>

    <span slot="description" :style="{ color: sectionSelected.settings.style.fontColor }">{{ data.description }}</span>
    <span slot="duration">3:50</span>
    <span slot="tag">Tag</span>
  </component>
</template>
<script>
  import {vmImage, vmImageBackground} from '@fremcast/section/Image';
  import {videoRoute, customRoute, iconRoute} from '@fremcast/section/RouteLink';
  import FremcastImage from "@fremcast/section/ImageVideoCard";
  import section from '@fremcast/section/mixins/section';
  import card from '@fremcast/section/mixins/card';
  import * as SectionsConfig from '@fremcast/section/config';
  import stylesButton from "@fremcast/section/mixins/stylesButton";

  export default {
    data() {
      return {
        sectionSelectedId: 0,
        //sectionTextColor: "#FFF",
        blockStyle: 'card',
        sectionSelectedBlockId: 0
      };
    },
    created() {
      this.blockStyle = this.sectionSelected.settings.blockStyle.toLowerCase();
      this.textColor = this.sectionSelected.titleColor;
      this.sectionSelectedId = this.sectionSelected.sectionId;
      this.sectionSelectedBlockId = this.sectionSelected.id
    },
    props: [
      'data',
      'css'
    ],
    components: {
      vmImage,
      videoRoute,
      customRoute,
      vmImageBackground,
      iconRoute,
      FremcastImage
    },
    mixins: [
      section,
      card,
      stylesButton
    ],
    watch: {
      sectionSelected: {
        handler: function (value) {
          this.blockStyle = value.settings.blockStyle.toLowerCase();
        },
        deep: true
      }
    }
  }
</script>
